import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface TierCellProps {
  productId: string;
  tier: string;
}

export function TierCell({ tier, productId }: TierCellProps): ReactElement {
  const { t } = useTranslation();

  return <span>{t(`${productId}.tiers.${tier}.label`)}</span>;
}
